import type { RouteRecordRaw } from 'vue-router'
import { routes } from '@app/router/routes'

export const dashboardRoutes: RouteRecordRaw[] = [
  {
    path: routes.DASHBOARD,
    name: 'DASHBOARD',
    component: () => import('./DashboardPage.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: routes.MARKET_PULSE,
    name: 'MARKET_PULSE',
    component: () => import('./MarketPulseListPage.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: routes.MARKET_PULSE_ARTICLE,
    name: 'MARKET_PULSE_ARTICLE',
    component: () => import('./MarketPulseArticlePage.vue'),
    meta: { requiresAuth: false },
  },
  {
    path: routes.EXPLORE_VIDEOS,
    name: 'EXPLORE_VIDEOS',
    component: () => import('./ExploreVideosPage.vue'),
    meta: { requiresAuth: false },
  },
]
